"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentConsentCheckbox = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _components = require("../../components");
var _utils = require("../../utils");
var _excluded = ["form", "checked", "className", "onChange"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var TermsLink = function TermsLink(_ref) {
  var url = _ref.url,
    children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_components.BaseButton, {
    className: "inline tw-caption-medium text-green1-55",
    url: url
  }, children);
};
var PaymentConsentCheckbox = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var form = _ref2.form,
    checked = _ref2.checked,
    className = _ref2.className,
    _ref2$onChange = _ref2.onChange,
    onChange = _ref2$onChange === void 0 ? _lodash.noop : _ref2$onChange,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/_react.default.createElement(_components.Checkbox, _extends({
    form: form,
    checked: checked,
    name: "acceptSelfPayAgreement",
    onChange: onChange,
    wrapperStyles: className,
    ref: ref
  }, props), /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-body-sm-regular text-grey-75"
  }, "I've read and agree to the", ' ', /*#__PURE__*/_react.default.createElement(TermsLink, {
    url: _utils.TELEHEALTH_INFORMED_CONSENT_URL
  }, "Informed Consent to Telehealth Visit"), ", ", /*#__PURE__*/_react.default.createElement(TermsLink, {
    url: _utils.PATIENT_AUTHORIZATION_URL
  }, "Patient Authorization"), ", and the", ' ', /*#__PURE__*/_react.default.createElement(TermsLink, {
    url: _utils.CONSENT_TO_MEDICAL_CARE_URL
  }, "Consent to Medical Care")));
});
exports.PaymentConsentCheckbox = PaymentConsentCheckbox;